import type {
    GetPublicacionCartaDigitalBySlugParams,
    GetPublicacionCartaDigitalBySlugResponse,
} from '@contracts/api/publicaciones-cartas-digitales'
import { api } from './api'

export const getPublicacionCartaDigitalBySlug = async (
    params: GetPublicacionCartaDigitalBySlugParams
): Promise<GetPublicacionCartaDigitalBySlugResponse> => {
    const { data } = await api.get<GetPublicacionCartaDigitalBySlugResponse>(
        'api/v1/publicaciones-cartas-digitales/por-slug',
        { params }
    )
    return data
}
